/*
 * @Author: wangweixin
 * @Date: 2017-12-15 11:00:11
 * @Last Modified by: wangweixin
 * @Last Modified time: 2020-07-27 15:16:29
 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { iconMap } from './iconMap';

/**
 * icon的基本封装
 */
function Icon(props) {
  const { link, className = '', mini, type, style, ...others } = props;
  const classes = classnames('icon', className, {
    mini
  });

  const resultLink = type ? iconMap[type] : link;
  return (
    <svg className={classes} {...others} style={style}>
      <use xlinkHref={resultLink} />
    </svg>
  );
}

Icon.propTypes = {
  /** svg的路径 */
  link: PropTypes.string.isRequired,
  /** 小尺寸 */
  mini: PropTypes.bool
};

Icon.defaultProps = {
  mini: false
};

export default Icon;
